export default __webpack_public_path__ + "static/slash-light-mode-841cd0a8c3916c67c11b6edf00136cdb.mp4";